import React, { useEffect, useRef, useState } from 'react';
import { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useWindowSize } from 'react-use';
import { toast } from 'react-toastify';
import Confetti from 'react-confetti';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const PaymentStatus = () => {
  const query = useQuery();
  const hasMounted = useRef(false);
  const transactionId = query.get('transactionId');
  const processID = query.get('processID');
  const referralLink = query.get('referralLink');
  const status = query.get('status');
  const giftLogsLink = `/Gift/giftLogs/${referralLink}`;
  const token = localStorage.getItem('token');
  const isPayment = localStorage.getItem('isPayment') === 'true';
  const isActive = useSelector((state) => state.toggle.isActive);
  const navigate = useNavigate();


  const [showConfetti, setShowConfetti] = useState(false);
  const [numOfPieces, setNumOfPieces] = useState(200);
  const { width, height } = useWindowSize();
  const { t } = useTranslation();

  useEffect(() => {
    if (status === "success") {
      setShowConfetti(true);
      setNumOfPieces(200);

      const hideConfetti = setTimeout(() => {

        setNumOfPieces(0);
      }, 3000);

      const stopConfetti = setTimeout(() => {
        setShowConfetti(false);
      }, 10000);

      return () => {
        clearTimeout(hideConfetti);
        clearTimeout(stopConfetti);
      };
    }
  }, [status]);



  const hitCount = async () => {
    await postAsync('Utilities/PaymentHitAPI', {}, { projectID: referralLink, processID: processID })
      .then((response) => {
        const result = response?.data;
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };
  useEffect(() => {
    if (token) {
      localStorage.setItem('isHome', false);
    } else {
      localStorage.setItem('isHome', true);
    }
    if (status === 'success') {
      localStorage.removeItem('cart');
    }
  }, []);
  useEffect(() => {
    if (!hasMounted.current) {
      if (processID !== 6) {
        if (status === 'success' && processID != null && referralLink != null) {
          hitCount();
        }
      }
      hasMounted.current = true;
    }
  }, []);

  useEffect(() => {
    (async () => {
      const response = await getAsync(`GiftService/GetGiftBeneficiaryByGiftLogLink/${referralLink}`);
      const newItem = response?.data;
      if (newItem.length > 0 && newItem !== undefined) {
        let arrayLink = [];
        newItem?.forEach((element) => {
          const link = `${reactURL}/Gift/${element.giftLinkID}`;
          arrayLink.push(link);
          console.log(arrayLink, 'arrayLinkarrayLink');
        });
      }
    })();
  }, []);



  return (
    <div className=' py-4  '>
      {showConfetti && <Confetti
        width={width}
        height={height}
        numberOfPieces={numOfPieces}
      />}
      {isPayment && (
        <section className="text-gray-600 body-font pt-24   ">
          <div className="container max-w-xl rounded-lg mx-auto flex  py-10 items-center justify-center flex-col shadow-lg shadow-green-700">
            <img className="w-1/4  object-cover object-center rounded" alt="hero" src={`/assets/${status === 'success' ? 'successful' : 'failed'}.png`} />
            <div className="text-center w-full">
              <h1 className={`sm:text-3xl text-2xl mb-2 font-black ${status === 'success' ? 'text-customgreen' : 'text-red-700'} `}>{status === 'success' ? t('Payment Completed Successfully!') : t('Payment Failed!')}</h1>
              <h1 className="sm:text-xl text-xl mb-4 font-semibold ">{t('Transaction Number')}  <span className={isActive ? 'mr-2' : 'ml-2'}>:</span>   <span className={isActive ? 'mr-2' : 'ml-2'}>{transactionId}</span>  </h1>


              {(status === "success" && processID == 7) && (<p><a className='text-blue-600 hover:text-blue-700 underline font-black mb-4' href={`${giftLogsLink}`} target='_blank'>{giftLogsLink}</a></p>)}

              <p className="mb-4 leading-relaxed px-6 capitalize ">{t('you will be direct to the home page shortly or click here to return to home page')}</p>
              <div className="w-full px-6 ">
                <button
                  className="w-full text-center text-white border border-white bg-customgreen hover:bg-hovergreen hover:text-white focus:ring-4 focus:outline-none focus:ring-customgreen font-medium rounded-full text-lg p-1.5 flex justify-center items-center uppercase"
                  onClick={() => navigate('/')}
                >
                  {t('back to home')}
                </button>
              </div>
            </div>
          </div>
        </section>
      )}

    </div>
  );
};

export default PaymentStatus;